import {
    cardSvg,
    userSettingSvg,
    marketingDashboardSvg,
    settlements,
    transactions,
    receiveMoney,
    gateways,
    walletSvg,
    Pishkan,
    paymentWithId
    // paymentWithId
} from '../svg/asideIconSvg.js';

export default [
    {
        url: '/',
        title: 'پیشخوان',
        need_auth: false,
        icon: Pishkan
    },
    {
        url: '/gateways',
        title: 'درگاه پرداخت',
        need_auth: true,
        icon: gateways
    },
    {
        url: '/receive-money',
        title: 'فاکتور آنلاین',
        need_auth: true,
        icon: receiveMoney
    },
    // {
    //     url: '/payment-id',
    //     title: 'پرداخت شناسه‌دار',
    //     need_auth: true,
    //     icon: paymentWithId
    // },
    // {
    //     url: '/wallets',
    //     title: 'مدیریت تسویه',
    //     need_auth: true,
    //     icon: walletSvg
    // },
    {
        url: '/transactions',
        title: 'تراکنش',
        need_auth: true,
        icon: transactions
    },
    {
        url: '/settlements',
        title: 'تسویه حساب',
        need_auth: true,
        icon: settlements
    },
    // {
    //     url: '/card',
    //     title: 'دستگاه کارتخوان',
    //     need_auth: true,
    //     icon: cardSvg
    // },
    {
        url: '/marketing/dashboard',
        title: 'همکاری در فروش',
        need_auth: true,
        icon: marketingDashboardSvg
    },
    {
        url: '/user-setting',
        title: 'تنظیمات',
        need_auth: true,
        icon: userSettingSvg,
        has_badge: true
    }
];